function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.725 17.8"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.425 16.1l-4.9-4.9a6.9 6.9 0 00-.7-9.1 6.662 6.662 0 00-4.9-2.1 6.662 6.662 0 00-4.9 2.1 7.063 7.063 0 000 9.9 6.966 6.966 0 004.9 2 7.294 7.294 0 004.2-1.4l4.9 4.9a.967.967 0 001.4 0 .967.967 0 000-1.4zm-14-5.6a5.134 5.134 0 010-7.1 5 5 0 013.5-1.4 4.691 4.691 0 013.5 1.5 5.289 5.289 0 011.5 3.5 4.691 4.691 0 01-1.5 3.5 5.289 5.289 0 01-3.5 1.5 4.691 4.691 0 01-3.5-1.5z"
})));